import _implicitStylesheets from "./moreResourcesSectionV2.css";
import _implicitScopedStylesheets from "./moreResourcesSectionV2.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import _wdsLink from "wds/link";
import _axCard from "ax/card";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3 type-style="display-6" class="resource-card__title${0}"${2}>${"t1"}</h3>`;
const $fragment2 = parseFragment`<span${3}>${"t1"}</span>`;
const $fragment3 = parseFragment`<span${3}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "resource-card": true
  },
  props: {
    "padding": "large",
    "border": "true"
  },
  key: 0
};
const stc1 = {
  classMap: {
    "resource-card__header": true
  },
  key: 1
};
const stc2 = {
  "resource-card__header-icon": true
};
const stc3 = {
  classMap: {
    "resource-card__links": true
  },
  key: 5
};
const stc4 = {
  "resource-card__link": true
};
const stc5 = {
  classMap: {
    "resource-card__link-icon": true
  },
  props: {
    "size": "small",
    "icon": "download",
    "ariaHidden": "true"
  },
  key: 9
};
const stc6 = {
  classMap: {
    "resource-card__link-icon": true
  },
  props: {
    "size": "small",
    "icon": "new_window",
    "ariaHidden": "true"
  },
  key: 13
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, k: api_key, b: api_bind, i: api_iterator} = $api;
  const {_m0} = $ctx;
  return [api_custom_element("ax-card", _axCard, stc0, [api_element("div", stc1, [api_custom_element("ax-icon", _axIcon, {
    classMap: stc2,
    props: {
      "icon": $cmp.headerIcon,
      "theme": $cmp.headerIconTheme,
      "ariaHidden": "true"
    },
    key: 2
  }), api_static_fragment($fragment1, 4, [api_static_part(1, null, api_dynamic_text($cmp.sectionTitle))])]), api_element("ul", stc3, api_iterator($cmp.resourceSection.resources, function (resource) {
    return api_element("li", {
      classMap: stc4,
      key: api_key(6, resource.id),
      on: {
        "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
      }
    }, [api_custom_element("wds-link", _wdsLink, {
      props: {
        "name": resource.caption
      },
      key: 7
    }, [resource.shouldDownload ? api_element("a", {
      attrs: {
        "href": resource.url,
        "target": "_blank",
        "download": resource.fileName
      },
      key: 8
    }, [api_custom_element("ax-icon", _axIcon, stc5), api_static_fragment($fragment2, 11, [api_static_part(1, null, api_dynamic_text(resource.caption))])]) : null, !resource.shouldDownload ? api_element("a", {
      attrs: {
        "href": resource.url,
        "target": "_blank"
      },
      key: 12
    }, [api_custom_element("ax-icon", _axIcon, stc6), api_static_fragment($fragment3, 15, [api_static_part(1, null, api_dynamic_text(resource.caption))])]) : null])]);
  }))])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2qo4btbj182";
tmpl.legacyStylesheetToken = "undefined-_moreResourcesSectionV2";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
